module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./TopicAgreementView.js"));
	}, "TopicAgreementView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TopicAgreementView!./src/pages/Shop/Member/Agreements/TopicAgreement/TopicAgreementView.js
// module id = 1875
// module chunks = 367